import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const Text = ({
  v2,
  gap = 8,
  children,
  className,
  style,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    ...props,
    className: cx(styles.box, className, {
      [styles.v2]: v2
    }),
    style: {
      ...style,
      "--text-gap": `${gap}px`
    }
  },
  /* @__PURE__ */ React.createElement("div", { className: cx(styles["box-inner"]) }, children)
);
Text.displayName = "Text";

export { Text };
//# sourceMappingURL=index.js.map
